import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { loading } = useAuth();
  const adminAuth = localStorage.getItem('adminAuth');

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner"></div>
      </div>
    );
  }

  return adminAuth === 'true' ? children : <Navigate to="/admin/login" replace />;
};

export default PrivateRoute;


